import React, { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  Input,
  FormControl,
  Select,
} from "@material-ui/core/";

import { connect } from "react-redux";

import { acceptingOrder } from "../../../../actions/sellerActions";

const AcceptingOrder = (props) => {
  const [days, setDays] = useState("0");
  const [minutes, setMinutes] = useState("0");
  const [hours, setHours] = useState("0");
  return (
    <div>
      <Dialog disableBackdropClick disableEscapeKeyDown open={true}>
        <DialogTitle>
          Select Approximate Time For Full Filling The Order
        </DialogTitle>
        <DialogContent>
          <form style={{ display: "flex", flexWrap: "container" }}>
            <FormControl style={{ minWidth: 120 }}>
              <InputLabel htmlFor="demo-dialog-native">Days</InputLabel>
              <Select
                native
                value={days}
                onChange={(e) => setDays(e.target.value)}
                input={<Input id="demo-dialog-native" />}
              >
                <option value={0}>0</option>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
                <option value={6}>6</option>
                <option value={7}>7</option>
              </Select>
            </FormControl>
            <FormControl style={{ minWidth: 120 }}>
              <InputLabel htmlFor="demo-dialog-native">Hours</InputLabel>
              <Select
                native
                value={hours}
                onChange={(e) => setHours(e.target.value)}
                input={<Input id="demo-dialog-native" />}
              >
                <option value={0}>0</option>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
                <option value={6}>6</option>
                <option value={7}>7</option>
                <option value={8}>8</option>
                <option value={9}>9</option>
                <option value={10}>10</option>
                <option value={11}>11</option>
                <option value={12}>12</option>
              </Select>
            </FormControl>
            <FormControl style={{ minWidth: 120, marginLeft: 20 }}>
              <InputLabel id="demo-dialog-select-label">Minutes</InputLabel>
              <Select
                native
                labelId="demo-dialog-select-label"
                id="demo-dialog-select"
                value={minutes}
                onChange={(e) => setMinutes(e.target.value)}
                input={<Input />}
              >
                <option value={0}>0</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={40}>40</option>
                <option value={50}>50</option>
                <option value={60}>60</option>
              </Select>
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            disabled={days === "0" && minutes === "0" && hours === "0"}
            onClick={() => {
              props.acceptingOrder(
                props.match.params.orderID,
                minutes,
                hours,
                days
              );
              props.history.push(`/dashboard/${props.auth.seller._id}`);
            }}
          >
            Confirm Order
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { acceptingOrder })(AcceptingOrder);
